import React from 'react';
import { DataList } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';
import useService from '../../../useService';
import { columnConfigs, DEFAULT_CONFIG } from './listConfig';

const UserSegmentList: React.FC<{}> = () => {
	const { requestGetSegment } = useService();
	return (
		<DataList
			fetchData={requestGetSegment}
			columnConfigs={columnConfigs}
			defaults={DEFAULT_CONFIG}
			disablePagination={false}
			disablePaginationSelect={false}
			entity={LIST_ENTITY_NAMES.USER_SEGMENT}
			disableColumnFilter
			filterable={false}
			searchable={false}
		/>
	);
};

export default UserSegmentList;
